/**
 * Small color square for preset/template pickers (filter presets, CSV templates).
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

export interface PresetColorSwatchProps {
  color: string;
  className?: string;
}

export const PresetColorSwatch: FC<PresetColorSwatchProps> = ({ color, className }) => (
  <span
    className={className ?? 'h-3 w-3 shrink-0 rounded-[3px]'}
    style={{ backgroundColor: color }}
    aria-hidden
  />
);
